export default "__VITE_ASSET__DVdB47Cp__"